export default "__VITE_ASSET__C_1MSj6e__"